document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-toggle]');
  if (t) {
    var el = document.getElementById(t.getAttribute('data-toggle'));
    if (el) { el.classList.toggle('is-open'); e.preventDefault(); }
  }
  var c = e.target.closest('[data-close]');
  if (c) {
    var p = document.getElementById(c.getAttribute('data-close'));
    if (p) { p.classList.remove('is-open'); e.preventDefault(); }
  }
});
document.addEventListener('click', function (e) {
  document.querySelectorAll('.drawer.is-open').forEach(function (d) {
    if (e.target === d) d.classList.remove('is-open');
  });
});
document.addEventListener('keyup', function (e) {
  if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
});
